// extracted by mini-css-extract-plugin
export default {"primaryColor":"#4a90e2","secondaryColor":"#357ebd","tertiaryColor":"#1d5b96"};